import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "blt1"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "hasChildren"
}, [
  /*#__PURE__*/_createTextVNode(" その他 "),
  /*#__PURE__*/_createElementVNode("span", { class: "blt1" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedItems, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.categoryId
        }, [
          _createElementVNode("a", null, [
            _createTextVNode(_toDisplayString(item.itemName) + " ", 1),
            (item.children && item.children.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1))
              : _createCommentVNode("", true)
          ]),
          (item.children && item.children.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: child.categoryId
                    }, [
                      _createElementVNode("a", null, _toDisplayString(child.itemName), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      (_ctx.otherItems.length > 0)
        ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", null, [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherItems, (other) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: other.categoryId
                  }, [
                    _createElementVNode("a", null, _toDisplayString(other.itemName), 1)
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}